import { toFlatField } from '../oasis-types';
export const MedicationVersioned = {
    medication: { e1: { alias: 'medication', timepoint: ['*'] } },
};
export const Medication = toFlatField(MedicationVersioned);
